<template>
    <div>
      <div class="training-course-list">
        <a class="training-course-list-item _new" v-for="course in training_courses"
           :href="course.has_page ? '/training/course/' + course.id : '#'"
           @click="course.has_page ? null : openModal(course)"
        >
          <div class="box">
            <div class="image">
              <img :src="course.image_url">
            </div>
            <div class="content">
              <div class="title">
                {{ course.name }}
              </div>
              <ul class="duration" v-if="course.duration !== null || course.training_course_type !== null || course.full_cost !== null">
                <li v-if="course.duration !== null &&  course.duration !== ''">
                  {{ course.duration }}
                </li>
                <li v-if="course.training_course_type !== null">
                  {{ course.training_course_type.label }}
                </li>
                <li v-if="course.full_cost !== null && course.full_cost > 0">
                  <strong>Cost: </strong> <s class="txt-danger">£{{ course.full_cost }}</s> - <span class="txt-positive">£{{ course.epwin_cost }}</span> <span v-if="course.training_course_type_id === 3">(per person)</span>
                </li>
              </ul>
              <div class="description">
                {{ course.short_description }}
              </div>
            </div>
            <div class="footer">
              <div class="button">
                <a class="btn-primary" v-if="!course.has_page">
                  Enquire Now
                </a>
                <a class="btn-primary" v-else>
                  Learn More
                </a>
              </div>
              <!--                        <div class="level">-->
              <!--                            <div>-->
              <!--                                <i class="fa fa-user-graduate pr-2"></i> Level {{ course.level }}-->
              <!--                            </div>-->
              <!--                        </div>-->
            </div>
          </div>
        </a>
      </div>
        <div class="modal-window" :class="{'open': enquiry_box_open}" @click="enquiry_box_open = false">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="enquiry_box_open = false">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">Thank you for your interest</h1>
                </div>
                <div class="modal-content">
                    <p class="mt-0">
                       <strong>Course: '{{ selected_course.name }}'</strong>
                    </p>
                    <p>
                        Your enquiry will be sent to our team who will aim to respond within 48 hours, you will be sent a notification when you receive a reply.
                    </p>
                    <p>
                        If you would like to provide some more information please use the box below.
                    </p>
                    <div class="form-group">
                        <strong class="block pl-2 pb-1">Your Message</strong>
                        <textarea rows="5" v-model="enquiry_message" class="form-control"></textarea>
                    </div>
                </div>
                <div class="modal-footer align-right">
                    <a class="btn-primary" @click="sendEnquiry()">
                        Send
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    mounted() {
        this.loadCourses();
    },
    data() {
        return {
            training_courses: [],
            enquiry_box_open: false,
            enquiry_message: 'I would like some more information on this course.',
            selected_course: {},
        }
    },
    props: [
      'training_course_category',
    ],
    methods: {
        loadCourses() {
            axios.post('/training/loadCoursesAvailableForUserByCategory', {
              'training_course_category_id': this.training_course_category.id,
            }).then((response) => {
                this.training_courses = response.data;
            });
        },
        sendEnquiry() {
            let message = `Course: ${this.selected_course.name} - I would like some more information on this course.`;

            if(this.enquiry_message !== '') {
               message = `Course: ${this.selected_course.name} - ${this.enquiry_message}`
            }

          axios.post('/training/sendEnquiry', {
            'enquiry_type_id': this.selected_course.training_course_category.enquiry_type_id,
            'message': message,
          }).then((response) => {
            this.enquiry_box_open = false;
            Swal.fire({
              title: 'Enquiry Sent',
              icon: 'success',
              text: 'Your Enquiry has been sent, you will be sent a notification when you receive a reply.'
            });
          });
        },
      openModal(course) {
          this.selected_course = course;
          this.enquiry_box_open = true;
      },
    },
}
</script>
